import { useSpeckleStore } from '@haskoning/vue-speckle'
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { MODEL, useProjectSpeckleStore } from '../store/projectSpeckle'
import { storeToRefs } from 'pinia'

export const useSpeckleManagement = () => {
  const speckleStore = useSpeckleStore({ autoSelectData: false })
  const exportingSectionLines = ref(false)
  const store = useStore()
  const projectSpeckleStore = useProjectSpeckleStore()

  const { message } = storeToRefs(projectSpeckleStore)

  const currentProject = computed(() => store.state.project.currentProject)

  watch(
    () => speckleStore.currentSelection.project,
    async (newValue) => {
      if (!newValue) {
        return
      }
      await setModelInfo()
    }
  )

  async function setModelInfo() {
    await speckleStore.getSpeckleModels()
    const projectId = speckleStore.currentSelection.project?.id
    if (projectId) {
      await projectSpeckleStore.addDefaultModel(projectId)
    }
    for (const model of speckleStore.allModels) {
      if (model.name === MODEL) {
        speckleStore.currentSelection.model = model
        return
      }
    }
    speckleStore.currentSelection.model = undefined
  }

  watch(
    () => speckleStore.currentSelection.model,
    async (newValue) => {
      if (!newValue) {
        return
      }
      await setSpeckleVersion()
    }
  )

  async function setSpeckleVersion() {
    await speckleStore.getSpeckleVersions()
    for (const version of speckleStore.allVersions) {
      speckleStore.currentSelection.version = version
      return
    }
    speckleStore.currentSelection.version = undefined
  }

  onMounted(async () => {
    await speckleStore.getAllUserProjects()
  })

  const isValidInput = computed(() => {
    return [
      message.value,
      speckleStore.currentSelection.project,
      speckleStore.currentSelection.model
    ].every((item) => Boolean(item))
  })

  async function exportSectionLinesToSpeckle() {
    if (!isValidInput.value) {
      return
    }
    try {
      exportingSectionLines.value = true
      await projectSpeckleStore.send(currentProject.value.id, message.value)
    } finally {
      exportingSectionLines.value = false
    }
  }

  return {
    isValidInput,
    canUseSpeckle: speckleStore.canUseSpeckle,
    currentSelection: speckleStore.currentSelection,
    exportSectionLinesToSpeckle,
    exportingSectionLines
  }
}
